export const services = [
  {
    title: "Free Shipping",
    tagline: "On orders over $100",
    icon: "images/delivery-50.png",
  },
  {
    title: "Daily Deals",
    tagline: "Save up to 50%",
    icon: "images/giveaway-50.png",
  },
  {
    title: "Support 24/7",
    tagline: "Call us anytime",
    icon: "images/communicate-50.png",
  },
  {
    title: "Affordable Prices",
    tagline: "Factory direct prices",
    icon: "images/sale-50.png",
  },
  {
    title: "Secure Payments",
    tagline: "100% secure payment",
    icon: "images/bank-cards-50.png",
  },
];
